import md5 from 'md5';
import localStorage from '@/common/utils/storage';

/**
 * 记录课程详情页弹窗情况
 */
class CoursePopup {
  makeKey (userId) {
    return `series-popup-${md5(userId)}`;
  }

  checkAndSetIsFirstPopup (userId, sid, popupType) {
    const storageKey = this.makeKey(userId);

    const value = localStorage.get(storageKey) || '{}';
    let obj = {};

    obj[sid] = {};
    try {
      obj = { ...obj, ...JSON.parse(value) };
    } catch (e) {
      // do nothing
    }
    // 已经弹出过弹窗
    if (obj[sid][popupType]) {
      return false;
    }
    obj[sid][popupType] = true;

    localStorage.set(storageKey, JSON.stringify(obj));
    return true;
  }
}

export default new CoursePopup();
